<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Brick Details">
            <div style="position: relative">
              <div class="form-row">
                <div class="tickets-num"> 
                  <div class="ticket__head">
                    SIZE
                  </div>
                  <div class="ticket__head">
                   COST
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="tickets-num">
                  <div class="ticket__desc">
                    8” x 12”
                  </div>
                  <div class="ticket__amt">
                   $1,000
                  </div>
                  <input
                    id="largeBrick"
                    type="number"
                    min="1"
                    name="largeBrick"
                    placeholder="Number of 8” x 12” Bricks"
                    v-model="largeBrick"
                    @change="customQnt = true"
                  />

                </div>
              </div>

              <div class="form-row">
                <div class="tickets-num">
                  <div class="ticket__desc">
                    8” x 8”
                  </div>
                  <div class="ticket__amt">
                   $720
                  </div>                  
                  <input
                    id="regBrick"
                    type="number"
                    min="1"
                    name="regBrick"
                    placeholder="Number of 8” x 8” Bricks"
                    v-model="regBrick"
                    @change="customQnt = true"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="tickets-num"> 
                  <div class="ticket__desc">
                    4” x 8”
                  </div>
                  <div class="ticket__amt">
                   $360
                  </div>                                    
                  <input
                    id="smallBrick"
                    type="number"
                    min="1"
                    name="smallBrick"
                    placeholder="Number of 4” x 8” Bricks"
                    v-model="smallBrick"
                    @change="customQnt = true"
                  />
                </div>
              </div>
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection title="Would you like to add a donation?">
      <div class="styled-radio styled-radio--ou-donation row">
        <div v-for="amount of amounts" :key="amount" class="radio-part">
          <input
            :id="`amount${amount}`"
            type="radio"
            class="amount"
            @click="selectedAmount = amount"
            :checked="selectedAmount == amount"
          />
          <FormLabel :for="`amount${amount}`">
            <MoneyFormat
              class="label-amount"
              :value="amount"
              :currencyCode="form.currency"
              :hide-subunits="true"
            />
          </FormLabel>
        </div>
        <div class="amount_other__wrapper amount-row">
          <input
            id="amount_other_check"
            type="radio"
            class="amount"
            :checked="customSelected"
            @click="customSelected = true"
          />
          <input
            id="amount_other"
            type="number"
            min="1"
            name="amount_other"
            placeholder="Other"
            v-model="customAmount"
          />
        </div>
      </div>
    </FormSection>          
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <!-- <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly monthlyText="Monthly – To help cover operations."/>
            </div>
          </FormSection>          -->
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://jsu.org/privacy-policy/"/>
            </FormRow>  
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
            <FormRow>
                  <NewsletterSubscribe text="Sign me up for newsletter" />
            </FormRow> 
              <br>                
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>

        <div class="central__text">For more information contact Rabbi “Mike” Rovinsky, Executive Director JSU St. Louis at <a href="tel:314.498.6279">314.498.6279</a> or <a href="mailto:RabbiMike@jsustl.org">RabbiMike@jsustl.org</a></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const largeBrick = ref(0);
    const regBrick = ref(0);
    const smallBrick = ref(0);
    const coupon = ref();
    const customAmount = ref();
    const customSelected = ref(false);
    const customQnt = ref(false);
    const customVIPQnt = ref(false);

    let ticketCost = 0;
    let ticketVIPCost = 0;
    let tempAmount = 0;

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        setValue("custom.donationAmount", selectedAmount);
        customSelected.value = false;
        customAmount.value = null;
        setValue("amount", "" + (selectedAmount + ticketCost + ticketVIPCost));
      }
    });

    watch(customQnt, () => {
      customQnt.value = false;
      
      ticketCost = (1000 * largeBrick.value) + (720 * regBrick.value) + (360 * smallBrick.value);
      if (largeBrick || regBrick || smallBrick) {        
        setValue("custom.largeBrick", "" + (largeBrick.value));
        setValue("custom.regBrick", "" + (regBrick.value));
        setValue("custom.smallBrick", "" + (smallBrick.value));
        if (customSelected.value) {
          setValue("amount", "" + (tempAmount + ticketCost + ticketVIPCost));
        } else {
          setValue(
            "amount",
            "" +
              (ticketCost +
                ticketVIPCost +
                (selectedAmount.value ? selectedAmount.value : 0))
          );
        }
      }

    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      tempAmount = +customAmount;

      if (!selectedAmount.value) {
        setValue("custom.donationAmount", customAmount);
        setValue("amount", "" + (+customAmount + ticketCost + ticketVIPCost));
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts!;

      if (Array.isArray(amounts)) {
        return amounts;
      }

      return amounts[form.value.currency || "USD"];
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      customSelected,
      customQnt,
      getValue,
      setValue,
      largeBrick,
      regBrick,
      smallBrick
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

::v-deep .control-label{
  text-align: left !important;
}

.central__text{
  text-align: center;
  line-height: normal;
  padding: 20px 0px 10px;
  a{
    color: #1aa8d3;
  }
}

.tickets-num{
  display: flex;
    max-width: 600px;
    margin-bottom: 10px;
}

.ticket__desc, .ticket__amt {
  min-width: 23%;
    max-width: 23%;
    width: 23%;
    padding: 8px 12px;
    border: 1px solid gray;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 720px) {
      padding: 8px;
    }
}

.ticket__head{
  min-width: 23%;
    max-width: 23%;
    width: 23%;
    @media (max-width: 720px) {
      padding: 0px 8px;
    }
    display: flex;
    justify-content: center;
    align-items: center; 
    font-weight: 600;
}
.tickets-num input {
    flex: 1;
}

.ticket__amt {
    margin-right: 10px;
}

.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation .amount_other__wrapper {
  position: relative;
  margin-bottom: 10px;
  margin-right: 0;
  min-width: 16.6%;
  max-width: 31.6%;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  line-height: 1;
  @media (max-width: 720px) {
    margin-right: 5px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  &:before {
    content: "$";
    position: absolute;
    padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #fff;
    top: 0px;
    left: 0;
  }
  &.USD:before {
    content: "$";
  }
  &.CAN:before {
    content: "C$";
  }
  &.ILS:before {
    content: "₪";
  }

  input[type="number"] {
    border: none;
    margin-left: 20px;
    box-shadow: none;
    width: calc(100% + 20px);
    font-size: 12px;
  }
  &:after {
    display: none !important;
  }
}
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type="number"] {
      background: #fff;
      margin-top: -15px !important;
    }
  }
}

</style>
